// ─────────────────────────────────────────────────────────────────
// Sehat AI — Header Component
// ─────────────────────────────────────────────────────────────────

import React from 'react';
import { Volume2, VolumeX, MapPin, MapPinOff } from 'lucide-react';

export default function Header({ city, locationDenied, onRetryLocation, lang, voiceOn, onToggleLang, onToggleVoice }) {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 60%, #FBBF24 100%)',
      boxShadow: '0 4px 20px rgba(255,107,53,0.35)',
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '13px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
          <div style={{ width: 42, height: 42, borderRadius: 14, background: 'rgba(255,255,255,0.22)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 23 }}>
            🩺
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 900, color: '#fff', letterSpacing: '-0.4px' }}>
              Sehat <span style={{ fontStyle: 'italic', fontWeight: 800 }}>AI</span>
            </div>

            {/* Location status row */}
            <div style={{ fontSize: 10.5, color: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', gap: 5 }}>
              {locationDenied ? (
                // ── Location denied ──────────────────────────────────
                <>
                  <MapPinOff size={11} style={{ flexShrink: 0 }} />
                  <span style={{ color: 'rgba(255,255,255,0.7)' }}>Location off</span>
                  <button
                    onClick={onRetryLocation}
                    style={{
                      background: 'rgba(255,255,255,0.25)',
                      border: '1px solid rgba(255,255,255,0.5)',
                      borderRadius: 8, padding: '2px 8px',
                      color: '#fff', fontSize: 10, cursor: 'pointer',
                      fontFamily: "'Nunito',sans-serif", fontWeight: 800,
                      display: 'flex', alignItems: 'center', gap: 4,
                    }}
                  >
                    Allow <MapPin size={10} />
                  </button>
                </>
              ) : city ? (
                // ── Location known ───────────────────────────────────
                <>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#A7F3D0', display: 'inline-block', animation: 'pulse 2s infinite', flexShrink: 0 }} />
                  {city} · Aapka Health Assistant
                </>
              ) : (
                // ── Still fetching ───────────────────────────────────
                <>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'rgba(255,255,255,0.5)', display: 'inline-block', flexShrink: 0 }} />
                  Location dhundh rahi hoon...
                </>
              )}
            </div>
          </div>
        </div>

        {/* Controls */}
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={onToggleLang} style={{
            padding: '7px 13px', borderRadius: 20,
            border: '2px solid rgba(255,255,255,0.35)',
            background: 'rgba(255,255,255,0.18)',
            color: '#fff', fontSize: 12, cursor: 'pointer',
            fontFamily: "'Nunito', sans-serif", fontWeight: 800,
            backdropFilter: 'blur(5px)',
          }}>
            {lang === 'en' ? '🇮🇳 हिंदी' : '🇬🇧 English'}
          </button>
          <button onClick={onToggleVoice} style={{
            width: 38, height: 38, borderRadius: 12,
            border: '2px solid rgba(255,255,255,0.35)',
            background: voiceOn ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.18)',
            color: '#fff', fontSize: 17, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {voiceOn ? <Volume2 size={18} /> : <VolumeX size={18} />}
          </button>
        </div>
      </div>
    </div>
  );
}
